import React from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import './index.css';

import anetwork from '../../images/portfolio/mod-anetwork-m.jpg';
import fragaria from '../../images/portfolio/mod-fragaria.jpg';
import hotel from '../../images/portfolio/mod-hotel.jpg';
import tenders from '../../images/portfolio/mod-intenders.jpg';
import telephony from '../../images/portfolio/mod-iptelephony.jpg';
import lovelook from '../../images/portfolio/mod-lovelook.jpg';
import radar from '../../images/portfolio/mod-radar.jpg';
import raseBord from '../../images/portfolio/mod-rasa.jpg';
import sonder from '../../images/portfolio/mod-sonder.jpg';
import taxi306 from '../../images/portfolio/mod-taxi.jpg';
import travel from '../../images/portfolio/mod-travel.jpg';
import willy from '../../images/portfolio/mod-willy.jpg';
import zimbara from '../../images/portfolio/mod-zimbara.jpg';
import evrent from '../../images/portfolio/mod-evrent.jpg';
import viralvault from '../../images/portfolio/mod-viralvault.jpg';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    maxWidth: '1200px',
    height: '100%',
    border: 'none',
    padding: '0',
    overflow: "hidden",
    position: 'relative',
    transform: 'translate(-50%, -50%)'
  },
  overlay: {
    position: "fixed",
    top: "0px",
    left: "0px",
    right: "0px",
    bottom: "0px",
    backgroundColor: "rgba(0,0,0,.2)",
    zIndex: '100'
  }
};


export default class Presentation extends React.Component {
  constructor(props) {
    super(props)
    this.image = React.createRef();
  }

  getPresentation = (presentationTab) => {
    switch (presentationTab) {
      case 'Anetwork':
        return anetwork;
      case 'Willy':
        return willy;
      case 'Zimbara Goromi':
        return zimbara;
      case 'Fragaria':
        return fragaria;
      case 'Такси 306':
        return taxi306;
      case 'Love look':
        return lovelook;
      case 'Radar movie':
        return radar;
      case 'Rasa visual board':
        return raseBord;
      case 'Sonder':
        return sonder;
      case 'IP telephony':
        return telephony;
      case 'inTender':
        return tenders;
      case 'Travel life':
        return travel;
      case 'Hotel Pro':
        return hotel;
      case 'EvRent':
        return evrent;
      case 'Viral Vault':
        return viralvault;
      default:
      return anetwork;
    }
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={true}
          onRequestClose={() => this.props.history.push('/portfolio')}
          style={customStyles}>
          <div className="presentation__logo"></div>
          <div className="presentation__close" onClick={() => this.props.history.push('/portfolio')}></div>
          <div className="presentation__img">
            <img
              ref={this.image}
              src={this.getPresentation(this.props.current)}
              alt={this.props.current}
              style={{ width: '100%' }} />
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/presentation/index.jsx